import { getClientId } from 'owa-config';
import { getFallBackDeviceId } from './getFallBackDeviceId';

export function getNativeHostDeviceId(): string {
    return getClientId() ?? getFallBackDeviceId();
}
